import apiClient, { extractData } from '../api-client';

export const carrierApi = {
  list() {
    return apiClient.get('/carriers').then(extractData);
  },
  listCarriers() {
    return apiClient.get('/carriers').then(extractData);
  },
  setDefaultCarrier(provider) {
    return apiClient.post('/carriers/default', { provider }).then(extractData);
  },
  getSettings() {
    return apiClient.get('/carriers/settings').then(extractData);
  },
  setCarrierEnabled(provider, enabled) {
    return apiClient.post('/carriers/set-enabled', { provider, enabled }).then(extractData);
  },
  create(data) {
    return apiClient.post('/carriers', data).then(extractData);
  },
  update(id, data) {
    return apiClient.put(`/carriers/${id}`, data).then(extractData);
  },
  delete(id) {
    return apiClient.delete(`/carriers/${id}`).then(extractData);
  },

  // Key hãng vận chuyển (chỉ admin). Key thật chỉ trả về ở revealCredentials,
  // sau khi nhập lại mật khẩu đăng nhập; mọi chỗ khác chỉ có bản che.
  listCredentials() {
    return apiClient.get('/carriers/credentials').then(extractData);
  },
  saveCredentials(provider, body) {
    return apiClient.put(`/carriers/credentials/${provider}`, body).then(extractData);
  },
  testCredentials(provider) {
    return apiClient.post(`/carriers/credentials/${provider}/test`).then(extractData);
  },
  revealCredentials(provider, password) {
    return apiClient.post(`/carriers/credentials/${provider}/reveal`, { password }).then(extractData);
  },
};

// Alias used by GHTK shipping flow (plural naming).
export const carriersApi = carrierApi;
